import React from 'react';
import { FaFacebook, FaTwitter, FaInstagram, FaLinkedin, FaMapMarkerAlt, FaPhoneAlt, FaEnvelope } from 'react-icons/fa';

const Footer = () => {
    return (
        <footer className="bg-gradient-to-b from-blue-800 to-blue-900 text-white pt-16 pb-6">
            <div className="container mx-auto px-4">
                {/* Main footer content */}
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-12">
                    {/* Column 1: About */}
                    <div>
                        <h3 className="text-xl font-bold mb-4 border-b border-blue-700 pb-2 inline-block">About SeraphMed</h3>
                        <p className="text-blue-100 mb-4 leading-relaxed">
                            SeraphMed is a leading healthcare platform offering AI-powered solutions for better health outcomes, focused on delivering personalized care through innovative technology.
                        </p>
                        <div className="flex space-x-4 mt-6">
                            <a href="#" className="bg-blue-700 hover:bg-blue-600 p-2 rounded-full transition-colors duration-300">
                                <FaFacebook size={18} />
                            </a>
                            <a href="#" className="bg-blue-700 hover:bg-blue-600 p-2 rounded-full transition-colors duration-300">
                                <FaTwitter size={18} />
                            </a>
                            <a href="#" className="bg-blue-700 hover:bg-blue-600 p-2 rounded-full transition-colors duration-300">
                                <FaInstagram size={18} />
                            </a>
                            <a href="#" className="bg-blue-700 hover:bg-blue-600 p-2 rounded-full transition-colors duration-300">
                                <FaLinkedin size={18} />
                            </a>
                        </div>
                    </div>
                    
                    {/* Column 2: Quick Links */}
                    <div>
                        <h3 className="text-xl font-bold mb-4 border-b border-blue-700 pb-2 inline-block">Quick Links</h3>
                        <ul className="space-y-2">
                            <li>
                                <a href="#home" className="text-blue-100 hover:text-white transition-colors duration-300 flex items-center">
                                    <span className="mr-2">›</span> Home
                                </a>
                            </li>
                            <li>
                                <a href="#features" className="text-blue-100 hover:text-white transition-colors duration-300 flex items-center">
                                    <span className="mr-2">›</span> Features
                                </a>
                            </li>
                            <li>
                                <a href="#services" className="text-blue-100 hover:text-white transition-colors duration-300 flex items-center">
                                    <span className="mr-2">›</span> Services
                                </a>
                            </li>
                            <li>
                                <a href="#appointment" className="text-blue-100 hover:text-white transition-colors duration-300 flex items-center">
                                    <span className="mr-2">›</span> Book Appointment
                                </a>
                            </li>
                            <li>
                                <a href="#faq" className="text-blue-100 hover:text-white transition-colors duration-300 flex items-center">
                                    <span className="mr-2">›</span> FAQ
                                </a>
                            </li>
                            <li>
                                <a href="#privacy" className="text-blue-100 hover:text-white transition-colors duration-300 flex items-center">
                                    <span className="mr-2">›</span> Privacy Policy
                                </a>
                            </li>
                        </ul>
                    </div>
                    
                    {/* Column 3: Services */}
                    <div>
                        <h3 className="text-xl font-bold mb-4 border-b border-blue-700 pb-2 inline-block">Our Services</h3>
                        <ul className="space-y-2">
                            <li className="text-blue-100 hover:text-white transition-colors duration-300">AI Symptom Analysis</li>
                            <li className="text-blue-100 hover:text-white transition-colors duration-300">Telemedicine Consultations</li>
                            <li className="text-blue-100 hover:text-white transition-colors duration-300">Personalized Treatment</li>
                            <li className="text-blue-100 hover:text-white transition-colors duration-300">Health Monitoring</li>
                            <li className="text-blue-100 hover:text-white transition-colors duration-300">Medical Records</li>
                        </ul>
                    </div>
                    
                    {/* Column 4: Contact */}
                    <div>
                        <h3 className="text-xl font-bold mb-4 border-b border-blue-700 pb-2 inline-block">Contact Us</h3>
                        <ul className="space-y-3 text-blue-100">
                            <li className="flex items-start">
                                <FaMapMarkerAlt className="text-blue-300 mt-1 mr-3 flex-shrink-0" />
                                <span>123 Healthcare Avenue, Medical District, CA 90210</span>
                            </li>
                            <li className="flex items-center">
                                <FaPhoneAlt className="text-blue-300 mr-3 flex-shrink-0" />
                                <span>(810) 300-8298</span>
                            </li>
                            <li className="flex items-center">
                                <FaEnvelope className="text-blue-300 mr-3 flex-shrink-0" />
                                <span>contact@seraphmed.com</span>
                            </li>
                        </ul>
                        
                        {/* Newsletter signup */}
                        <div className="mt-6">
                            <h4 className="text-sm uppercase tracking-wider mb-2">Subscribe to our newsletter</h4>
                            <form className="flex">
                                <input 
                                    type="email" 
                                    placeholder="Your email" 
                                    className="bg-blue-700 text-white px-3 py-2 rounded-l-md focus:outline-none focus:ring-1 focus:ring-blue-300 w-full"
                                />
                                <button className="bg-blue-500 hover:bg-blue-400 px-4 py-2 rounded-r-md transition-colors">
                                    <span className="sr-only">Subscribe</span>
                                    <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                                        <path fillRule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clipRule="evenodd" />
                                    </svg>
                                </button>
                            </form>
                        </div>
                    </div>
                </div>
                
                {/* Divider */}
                <div className="border-t border-blue-700 pt-6 mt-6">
                    <div className="flex flex-col md:flex-row justify-between items-center">
                        <p className="text-sm text-blue-200 mb-4 md:mb-0">
                            &copy; {new Date().getFullYear()} SeraphMed. All rights reserved.
                        </p>
                        <div className="text-sm text-blue-200 space-x-6">
                            <a href="#terms" className="hover:text-white transition-colors duration-300">Terms of Service</a>
                            <a href="#privacy" className="hover:text-white transition-colors duration-300">Privacy Policy</a>
                            <a href="#cookies" className="hover:text-white transition-colors duration-300">Cookie Policy</a>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;